import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
interface ServiceCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  link: string;
}
export default function ServiceCard({
  title,
  description,
  icon,
  link
}: ServiceCardProps) {
  return <div className="bg-white rounded-lg shadow-md p-6 transition-all hover:shadow-xl border-t-4 border-primary card-lift group" data-id="element-412" data-mp="151fu6dym0n5h">
      <div className="text-primary mb-4 transform transition-transform group-hover:scale-110 group-hover:rotate-3" data-id="element-413" data-mp="1034jy24ekamq">
        {icon}
      </div>
      <h3 className="text-xl font-serif font-bold text-primary mb-2 group-hover:text-secondary transition-colors" data-id="element-414" data-mp="qbqfdfxlgkmq">
        {title}
      </h3>
      <p className="text-slate mb-4 leading-relaxed" data-id="element-415" data-mp="mbg8m11z9q6t">{description}</p>
      <Link to={link} aria-label={`Read more about ${title}`} className="inline-flex items-center text-primary font-medium hover:text-secondary transition-all group-hover:translate-x-2" data-id="element-416" data-mp="hblhbweaiyl8">
        Read More <ArrowRight className="ml-1 h-4 w-4" aria-hidden="true" data-id="element-417" data-mp="77fpe3dkw3r4" />
      </Link>
    </div>;
}